
export default () => {
    document.addEventListener('DOMContentLoaded', () => {
        const container = document.querySelector('[data-chronology]');
        if (!container) return;

        const isTopSwiper = document.body.classList.contains('nhkso100th');
        const isArchive = document.body.classList.contains('archive-chronology');

        const jsonUrl = container.dataset.src || 'chronology.json';
        const imgBase = container.dataset.imgBase || '';

        const loadingEl =
            container.querySelector('.chronology__loading') ||
            (() => {
                const p = document.createElement('p');
                p.className = 'chronology__loading';
                p.textContent = '読み込み中…';
                container.appendChild(p);
                return p;
            })();

        fetch(jsonUrl)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then((items) => {
                container.innerHTML = '';

                if (!Array.isArray(items) || items.length === 0) {
                    const empty = document.createElement('p');
                    empty.className = 'chronology__empty';
                    empty.textContent = '年表データがありません。';
                    container.appendChild(empty);
                    return;
                }

                // ==========================
                // ① nhkso100th：Swiper版
                // ==========================
                if (isTopSwiper) {
                    // Swiper DOM構築
                    const swiperEl = document.createElement('div');
                    swiperEl.className = 'chronology__swiper swiperChrono';

                    const wrapperEl = document.createElement('div');
                    wrapperEl.className = 'swiper-wrapper';

                    const frag = document.createDocumentFragment();

                    items
                        .filter(item => item.show === true)
                        .forEach((item) => {
                            const { yyyymm, pic, simpleText } = item;

                            const slide = document.createElement('div');
                            slide.className = 'chronology__item swiper-slide';

                            if (yyyymm?.trim()) {
                                const dateEl = document.createElement('p');
                                dateEl.className = 'chronology__date';
                                dateEl.textContent = yyyymm;
                                slide.appendChild(dateEl);
                            }

                            const hasImage = pic?.trim() && pic.trim() !== '.jpg';

                            if (hasImage) {
                                const figure = document.createElement('figure');
                                figure.className = 'chronology__figure';

                                const img = document.createElement('img');
                                img.className = 'chronology__img';
                                img.src = imgBase + pic;
                                img.alt = simpleText ? simpleText.slice(0, 40) : '';
                                figure.appendChild(img);

                                const cap = document.createElement('figcaption');
                                cap.className = 'chronology__caption';
                                cap.textContent = simpleText || '';
                                figure.appendChild(cap);

                                slide.appendChild(figure);
                            } else {
                                const body = document.createElement('p');
                                body.className = 'chronology__text';
                                body.textContent = simpleText || '';
                                slide.appendChild(body);
                            }

                            frag.appendChild(slide);
                        });

                    wrapperEl.appendChild(frag);
                    swiperEl.appendChild(wrapperEl);

                    // ナビ
                    const prevEl = document.createElement('div');
                    prevEl.className = 'swiper-prev';

                    const nextEl = document.createElement('div');
                    nextEl.className = 'swiper-next';

                    swiperEl.appendChild(prevEl);
                    swiperEl.appendChild(nextEl);

                    container.appendChild(swiperEl);

                    // Swiper 初期化
                    if (typeof Swiper === 'undefined') {
                        console.error('Swiper is not defined.');
                        return;
                    }

                    // eslint-disable-next-line no-undef
                    new Swiper(swiperEl, {
                        effect: 'slide',
                        direction: 'horizontal',
                        loop: false,

                        slidesPerView: 1.5,
                        spaceBetween: 0,

                        navigation: {
                            nextEl: nextEl,
                            prevEl: prevEl,
                        },

                        breakpoints: {
                            768: {
                                slidesPerView: 3.5,
                            },
                            1024: {
                                slidesPerView: 5.5,
                            },
                        },
                    });

                    return; // ここで終了
                }

                // ==========================
                // ② archive-chronology：Swiperなし版、リスト＋reveal＋遅延ロード
                // ==========================
                if (isArchive) {
                    const list = document.createElement('ol');
                    list.className = 'chronology__list';

                    const frag = document.createDocumentFragment();

                    items.forEach((item) => {
                        const { yyyymm, pic, text } = item;

                        const li = document.createElement('li');
                        // ★ ふわっと表示用に .reveal 付与
                        li.className = 'chronology__item reveal';

                        if (yyyymm?.trim()) {
                            const dateEl = document.createElement('p');
                            dateEl.className = 'chronology__date';
                            dateEl.textContent = yyyymm;
                            li.appendChild(dateEl);
                        }
                        // ★ figure + text を括るラッパ
                        const content = document.createElement('div');
                        content.className = 'chronology__content';

                        const hasImage = pic?.trim() && pic.trim() !== '.jpg';

                        if (hasImage) {
                            const figure = document.createElement('figure');
                            figure.className = 'chronology__figure';

                            const img = document.createElement('img');
                            img.className = 'chronology__img';
                            // ★ 遅延ロード：srcではなく data-src
                            img.dataset.src = imgBase + pic;
                            img.alt = text ? text.slice(0, 40) : '';
                            figure.appendChild(img);
                            content.appendChild(figure);
                        }

                        // テキスト本体（画像の有無に関わらず出す）
                        if (text) {
                            const body = document.createElement('p');
                            body.className = 'chronology__text';
                            body.textContent = text;
                            content.appendChild(body);
                        }

                        // ★ ラッパを li に追加
                        li.appendChild(content);

                        frag.appendChild(li);
                    });

                    list.appendChild(frag);
                    container.appendChild(list);

                    // ★ このコンテナ内の .reveal をふわっと＋遅延ロード
                    initChronologyReveal(container);
                    return;
                }
            })
            .catch((err) => {
                console.error(err);
                loadingEl?.remove();
                const error = document.createElement('p');
                error.className = 'chronology__error';
                error.textContent = '年表データの読み込みに失敗しました。';
                container.appendChild(error);
            });
    });


    // ===========================
    // archive-chronology 用 reveal + lazy
    // ===========================
    function initChronologyReveal(root) {
        // このコンテナ内だけ対象にする（他の .reveal と切り分け）
        const targets = root.querySelectorAll('.reveal');
        if (!targets.length) return;

        const onReveal = (el) => {
            // 画像の遅延ロード（あれば）
            const imgs = el.querySelectorAll('img[data-src]');
            imgs.forEach((img) => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            });

            // ふわっと表示
            el.classList.add('is-visible');
        };

        if (!('IntersectionObserver' in window)) {
            targets.forEach(onReveal);
            return;
        }

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    onReveal(entry.target);
                    obs.unobserve(entry.target);
                });
            },
            {
                threshold: 0.4,            // 要素の 40% が見えたら
                rootMargin: '0px 0px 0px 0px', // マージンは素直に 0
            }
        );

        targets.forEach((el) => observer.observe(el));
    }


}
